export default "__VITE_ASSET__DwMYPaef__"